import React from "react";
import styled from "styled-components";

const StyledFooter = styled.footer`
  display: flex;
  justify-content: center;
  color: var(--primary-text-color);
  font-size: 0.7rem;
`;

const Footer = () => {
    return <StyledFooter>
                <span>© 2022 Going Shopping. All rights reserved.</span>
    </StyledFooter>
}

export default Footer;